import {Component, EventEmitter, inject, Input, OnDestroy, Output} from '@angular/core';
import {finalize, takeUntil} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {BaseService} from "../../../services/base.service";
import {LocalStorageService} from "../../../services/local-storage.service";
import {Subject} from "rxjs";
import {GoodsService} from "../../../services/goods.service";
import {RequestData} from "../../../interfaces/request-data";

@Component({
  selector: 'app-modal-good-add-to-basket-mobile',
  templateUrl: './modal-good-add-to-basket-mobile.component.html',
  styleUrls: ['./modal-good-add-to-basket-mobile.component.scss', '../../account/account.component.scss']
})
export class ModalGoodAddToBasketMobileComponent extends BaseService implements OnDestroy {
  @Input() basketModalData: {
    index: number,
    name: string,
    pack_id: number,
    warehouse: number,
    count: number,
    gid: string,
    sup_wh_id?: number
  } = {
    index: 0,
    name: '',
    pack_id: 0,
    warehouse: 0,
    count: 1,
    gid: null,
    sup_wh_id: null
  };

  @Output() getBasket = new EventEmitter();
  @Output() isDarkBackgroundEvent = new EventEmitter();

  isDestroyed: Subject<boolean> = new Subject();

  private http: HttpClient = inject(HttpClient);
  private localStorage: LocalStorageService = inject(LocalStorageService);
  private goodsService: GoodsService = inject(GoodsService);

  isBasketModalShow: boolean = false;
  isDarkBackground: boolean = false;
  isSending: boolean = false;

  modalShow() {
    this.isBasketModalShow = true;
    this.isDarkBackground = true;
  }

  minusBasketCountGoodModal() {
    this.basketModalData.count -= 1;

    if (this.basketModalData.count === 0) {
      this.basketModalData.count = 1;
    }
  }

  plusBasketCountGoodModal() {
    this.basketModalData.count += 1;
  }

  sendMobileBasket() {
    // add_basket додає до наявної кількості - подвійний тап клав товар двічі
    if (this.isSending) {
      return;
    }

    const payload: any = {
      package_id: this.basketModalData.pack_id,
      count: this.basketModalData.count,
      warehouse: this.basketModalData.warehouse,
      delivery: this.localStorage.get('delivery_id'),
      gid: this.basketModalData.gid
    };

    // Склад партнёра (контракт п.3 с бэком): пока бэк поле не читает — кладёт как раньше, без склада
    if (this.basketModalData.sup_wh_id) {
      payload.sup_wh_id = this.basketModalData.sup_wh_id;
    }

    this.isSending = true;

    this.http.post(this.apiRoot + 'basket_data/add_basket', payload)
      .pipe(
        takeUntil(this.isDestroyed),
        finalize(() => this.isSending = false)
      )
      .subscribe((data: RequestData) => {
        this.isBasketModalShow = false;
        this.isDarkBackground = false;

        this.basketModalData.count = 1;

        this.goodsService.notifyAddBasketError(data);

        this.isDarkBackgroundEvent.emit();

        this.getBasket.emit();
      })
  }

  closeModal() {
    this.isBasketModalShow = false;
    this.isDarkBackground = false;
    this.isDarkBackgroundEvent.emit();
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
